import PersonIcon from '@mui/icons-material/Person';

export default PersonIcon;
